import { render, staticRenderFns } from "./GensenForm.vue?vue&type=template&id=26b2c2f6&"
import script from "./GensenForm.vue?vue&type=script&lang=js&"
export * from "./GensenForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports